import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import { useState } from 'react'
import SimpleDialog from './SimpleDialog'

type Props = {
  onDelete: () => void
  title?: string
  message?: string
}

export function DeleteRecord({ onDelete, title, message }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Tooltip title="Deletar registro" aria-label="Deletar registro">
        <IconButton onClick={() => setIsModalOpen(true)}>
          <DeleteOutlineIcon />
        </IconButton>
      </Tooltip>
      <SimpleDialog
        message={message || 'Deseja realmente deletar esse item?'}
        open={isModalOpen}
        buttonLabel="Não"
        handleClose={() => setIsModalOpen(false)}
        primaryAction={onDelete}
        title={title || 'Deletar este Registro'}
        primaryActionButtonLabel="Sim"
      />
    </>
  )
}
